var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacMauvaiseReponse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sac",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 293.23 459.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-16,.cls-2{stroke:#fff;}.cls-1,.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-2,.cls-9{stroke-miterlimit:10;}.cls-1{stroke-width:6px;}.cls-2{stroke-width:5px;}.cls-3{fill:#2a2a28;}.cls-4{fill:#f8b71f;}.cls-5{fill:#4c4e4d;}.cls-6{fill:#202120;}.cls-7{fill:#ffd02e;}.cls-8{fill:#1c1c1c;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-9{fill:none;stroke-width:2px;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-9{stroke:#b3b3ba;}.cls-10{stroke-dasharray:5.95 1.98;}.cls-11{opacity:0.67;}.cls-12{stroke-dasharray:6.92 2.31;}.cls-13{stroke-dasharray:4.25 1.42;}.cls-14{stroke-dasharray:5.29 1.76;}.cls-15{stroke-dasharray:5.79 1.93;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sac mauvaise r\xE9ponse 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2_mauvaise",
    "data-name": "2 mauvaise"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 153.23,
    cy: 74,
    r: 71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.07,834l-37.16,47",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1052.77,955.26c7.21-61.86,36-125.62,25.1-135.26C1054.22,799,974,792,974,792s-80.22,7-103.87,28c-10.85,9.64,14.15,67.65,21.37,129.5l-1,134h164Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.93,834l37.16,47",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M892.5,888.5,863,1097c-6.54,18.5-26.83,16-28.54-1.5,0,0,12-254.5,35.63-275.5",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1054.5,893.5l27.93,203.5c6.07,23.5,27.36,16,29.07-1.5,0,0-9.52-254.5-33.16-275.5",
    transform: "translate(-820.77 -655)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sac-2",
    "data-name": "sac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M909.71,1062.8s-67.18-14.9-69.55-16.26-2.25-1.87-2.25-1.87-7.72-2.61-8.88-3.42-4.93-3-5.62-7-.82-11.48.92-22.36c-3.37-8.58-2.62-30.16-2.12-34.61s3-17.57,5.44-22.11a70.65,70.65,0,0,1,4-6.85s.07-3.75.81-4.65,5-.71,5.26-.65,4.12-.38,4.36-1.4,18.22-49.21,23-57,21.53-31.78,31.59-34C896.25,843.36,901,808,904,805s19-8,19-8,12.7-.14,14,3l4.4,45.59,18.15,4Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M937.26,944.92l-60.11-14.13s2.13-12.82,9.09-15.88c3.59-1.58,8.3-1,13.39.17L941.92,925Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "29.34 378.82 56.38 275.79 116.51 289.84 92.27 393.53 29.34 378.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M839.67,1031.38s31.5-106,34.71-111.72,11.07-10.58,14.76-10.25,25.42,2.72,34,4.17,20.78,3.32,20.78,3.32l-.84,3.15s-49.49-8.81-54-7.72-10.25,5.93-11,8.16-33.69,112-33.69,112Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M825.13,1035s9.83-24.84,15-41.36,29.17-88,30.16-98l-2-.48s-38.49,104.92-41.35,117.15C825,1020.69,825.13,1035,825.13,1035Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M904.44,872.68l19.11,4.47s4.88-28.95,8.27-35.42,9.69-21.91,10-24.26a5,5,0,0,1-.84-1s7.8-4.62,26.22.49l1.61-6.88s-12.31-3.68-24.15-2.42c-2,.35-4.71-.56-6,.22s-2.61,3.15-6.68,6.76c-5.31,5.48-10.3,7.27-13.84,12.08S906.62,862.18,904.44,872.68Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 915,
    y: 948.55,
    width: 19.62,
    height: 13.08,
    transform: "translate(-579.12 -840.42) rotate(13.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 869.01,
    y: 963.92,
    width: 62.27,
    height: 6.02,
    transform: "translate(-577.08 -834.49) rotate(13.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M878.35,959s-.08-.82-1.35-1.12-2.46,1.31-2.46,1.31l-1.78-.42a2.45,2.45,0,0,1-1.12,1.35c-.94.58-3,12.74-3,12.74s-1.09,3.5,2,4.22a3.4,3.4,0,0,0,4-2.28s.82-8.14,1.24-9.92c.57-.14,1.38-1.29,1.38-1.29l3.31.77,1.07-4.59Zm-7.48,17.06a2.09,2.09,0,1,1,2.51-1.56A2.08,2.08,0,0,1,870.87,976.07Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M942.6,915.19l-1.86-1.25s-4.65-.81-5-.36-2.14,1.11-1.81,2l.39.63s-2.09,4.35-2.07,5.43a2.58,2.58,0,0,0,2,2.89c1.78.41,3.49,0,4-.95s.68-5.22.68-5.22l2.3.54a2,2,0,0,0,1.19-.53C942.77,917.91,942.6,915.19,942.6,915.19Zm-7.74,8.4c-1.2-.28-2-1.08-1.87-1.78s1.27-1,2.46-.77,2,1.08,1.87,1.78S936.05,923.87,934.86,923.59Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M955.24,846.13l-3.7-1.4-3.89,2.85.76.18s-3.75,3.42-4.12,3.87a2.19,2.19,0,0,0-.42,1.79c.2.31,5.84.29,6.41.15s1.91-4.93,1.91-4.93l.81.19,4.84,1.14.24-1Zm-3.53,1.33,2-.6,2.63,1.41.45.38Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 61.07,
    y1: 213.21,
    x2: 63.99,
    y2: 213.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 65.92,
    y1: 214.34,
    x2: 126.73,
    y2: 228.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 127.7,
    y1: 228.78,
    x2: 130.62,
    y2: 229.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 84.73,
    y1: 216.59,
    x2: 87.65,
    y2: 217.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 89.9,
    y1: 217.79,
    x2: 97.76,
    y2: 219.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 98.88,
    y1: 219.89,
    x2: 101.8,
    y2: 220.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 87.71,
    y1: 203.85,
    x2: 90.63,
    y2: 204.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 92.87,
    y1: 205.05,
    x2: 100.73,
    y2: 206.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 101.86,
    y1: 207.15,
    x2: 104.78,
    y2: 207.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 87.71,
    y1: 203.85,
    x2: 87.02,
    y2: 206.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 86.7,
    y1: 208.15,
    x2: 85.57,
    y2: 212.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 85.41,
    y1: 213.66,
    x2: 84.73,
    y2: 216.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 104.78,
    y1: 207.84,
    x2: 104.09,
    y2: 210.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 103.77,
    y1: 212.14,
    x2: 102.64,
    y2: 216.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 102.48,
    y1: 217.65,
    x2: 101.8,
    y2: 220.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 87.71,
    y1: 203.85,
    x2: 89.64,
    y2: 206.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 90.78,
    y1: 207.49,
    x2: 99.3,
    y2: 217.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 99.87,
    y1: 218.28,
    x2: 101.8,
    y2: 220.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 104.78,
    y1: 207.84,
    x2: 102.03,
    y2: 209.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 100.41,
    y1: 209.74,
    x2: 88.29,
    y2: 215.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 87.48,
    y1: 215.39,
    x2: 84.73,
    y2: 216.59
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 60.35,
    y1: 216.26,
    x2: 63.28,
    y2: 216.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 65.21,
    y1: 217.4,
    x2: 126.02,
    y2: 231.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 126.98,
    y1: 231.84,
    x2: 129.91,
    y2: 232.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M830.56,1029c.13.43,1,1,2.44,1.65",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M834.78,1031.37c11.94,4.66,46.75,13.11,73.78,18.89",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M909.51,1050.46l2.94.62",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M909.71,1062.8s66.82,16.42,69.55,16.25,2.84-.67,2.84-.67,8.08,1.08,9.47.87,5.77-.54,8.13-3.75,5.82-9.92,9.08-20.44c6.82-6.2,15.72-25.88,17.25-30.1s5.06-17.08,4.92-22.22a72.53,72.53,0,0,0-.56-7.93s1.59-3.38,1.32-4.52-4.17-2.86-4.42-2.92-3.53-2.16-3.29-3.18,5.48-52.19,4.65-61.25-5.22-38-13.25-44.48c3.64-6.4,11.75-23.85,11.14-30.44,0-1.08-1.29-1.38-3.33-1.85S1003,837.4,1003,837.4a19.16,19.16,0,0,1-3.84-2,4.2,4.2,0,0,0-5.84-.29L977.58,854l-18-4.48Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M937.26,944.92l60.14,14s3.78-12.43-1.1-18.26c-2.52-3-7-4.58-12.09-5.78L941.92,925Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "155.2 408.24 176.63 303.89 116.51 289.84 92.27 393.53 155.2 408.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M986.42,1065.68s18.76-109,18.4-115.53-5.23-14.39-8.68-15.73-24-8.84-32.29-11.31-20.09-6.24-20.09-6.24l-.65,3.2s48.26,14,51.86,17,6.57,9.86,6.28,12.22-19.42,115.29-19.42,115.29Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M997.86,1075.34s2.19-26.62,4.85-43.74,12.87-91.83,16.4-101.22l2,.48s-12,111.11-14.86,123.35C1004.33,1062.61,997.86,1075.34,997.86,1075.34Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M998.7,894.71l-19.11-4.46s8.46-28.12,8.28-35.42,1-23.94,1.82-26.17a5,5,0,0,0,1.2-.53S986,820.53,967.17,817l1.61-6.88s12.66,2.15,22.72,8.54c1.61,1.18,4.47,1.58,5.25,2.83s1,4,3,9c2.33,7.27,6,11.08,7,17S1001.4,884.33,998.7,894.71Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 934.1,
    y: 953.02,
    width: 19.62,
    height: 13.08,
    transform: "translate(823.89 1453.77) rotate(-166.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 929.64,
    y: 978.09,
    width: 62.27,
    height: 6.02,
    transform: "translate(852.27 1500.12) rotate(-166.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M980.51,982.89l-1.07,4.58,3.31.78s.21,1.39.66,1.77c-.41,1.78-3.28,9.44-3.28,9.44a3.39,3.39,0,0,0,2.6,3.83c3.06.71,3.63-2.91,3.63-2.91s3.57-11.8,3-12.74a2.49,2.49,0,0,1-.41-1.71l-1.78-.41s-.35-2-1.62-2.26-1.71.4-1.71.4Zm.89,16.87a2.09,2.09,0,1,1,1.57,2.51A2.1,2.1,0,0,1,981.4,999.76Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M944.43,918.84a2,2,0,0,0,.84,1l2.29.54s-1.71,3.89-1.7,5,1.37,2.2,3.15,2.62,2.59-.74,3.09-1.7.54-5.78.54-5.78l.63-.39c.69-.65-.6-2-.74-2.59s-4.66-1.9-4.66-1.9l-2.21.29S944.3,918.27,944.43,918.84Zm2.57,6.24c.17-.7,1.27-1.05,2.47-.77s2,1.08,1.86,1.78-1.26,1-2.46.77S946.84,925.79,947,925.08Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M961.14,849.66l-.24,1,4.84,1.13.81.19s-.92,4.89-.47,5.26,5.5,2.9,5.81,2.71a2.2,2.2,0,0,0,.42-1.79c-.13-.57-2-5.3-2-5.3l.76.18-2.22-4.28-3.94-.38Zm1.27.3.57-.14,3-.11,1.55,1.44Z",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.17,
    y1: 245.72,
    x2: 197.25,
    y2: 245.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 195.32,
    y1: 244.58,
    x2: 134.51,
    y2: 230.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 133.54,
    y1: 230.14,
    x2: 130.62,
    y2: 229.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 177.46,
    y1: 238.26,
    x2: 174.54,
    y2: 237.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 172.3,
    y1: 237.05,
    x2: 164.44,
    y2: 235.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 163.32,
    y1: 234.95,
    x2: 160.4,
    y2: 234.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 180.44,
    y1: 225.52,
    x2: 177.52,
    y2: 224.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 175.28,
    y1: 224.32,
    x2: 167.42,
    y2: 222.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 166.29,
    y1: 222.22,
    x2: 163.37,
    y2: 221.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 180.44,
    y1: 225.52,
    x2: 179.76,
    y2: 228.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 179.44,
    y1: 229.82,
    x2: 178.31,
    y2: 234.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 178.15,
    y1: 235.34,
    x2: 177.46,
    y2: 238.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 163.37,
    y1: 221.53,
    x2: 162.69,
    y2: 224.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 162.37,
    y1: 225.83,
    x2: 161.24,
    y2: 230.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 161.08,
    y1: 231.35,
    x2: 160.4,
    y2: 234.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 180.44,
    y1: 225.52,
    x2: 177.69,
    y2: 226.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 176.08,
    y1: 227.43,
    x2: 163.95,
    y2: 232.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 163.14,
    y1: 233.07,
    x2: 160.4,
    y2: 234.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 163.37,
    y1: 221.53,
    x2: 165.31,
    y2: 223.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 166.44,
    y1: 225.18,
    x2: 174.96,
    y2: 235.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 175.53,
    y1: 235.97,
    x2: 177.46,
    y2: 238.26
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 199.46,
    y1: 248.78,
    x2: 196.54,
    y2: 248.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 194.61,
    y1: 247.64,
    x2: 133.79,
    y2: 233.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 132.83,
    y1: 233.2,
    x2: 129.91,
    y2: 232.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M995.65,1067.57c-.31.33-1.33.45-2.93.4",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M990.8,1067.84c-12.77-1.12-47.71-9-74.51-15.78",
    transform: "translate(-820.77 -655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M915.36,1051.82l-2.91-.74",
    transform: "translate(-820.77 -655)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1031,1002.74a72.53,72.53,0,0,0-.56-7.93s1.59-3.38,1.32-4.52-4.17-2.86-4.42-2.92-3.53-2.16-3.29-3.18,5.48-52.19,4.65-61.25-5.22-38-13.25-44.48c3.64-6.4,11.75-23.85,11.14-30.44,0-1.08-1.29-1.38-3.33-1.85S1003,837.4,1003,837.4l-.34-.14a44.16,44.16,0,0,1-2.87-6.79c-2-5-2.22-7.77-3-9s-3.64-1.65-5.25-2.83c-10.06-6.39-22.72-8.54-22.72-8.54s-12.31-3.68-24.15-2.42c-2,.35-4.71-.56-6,.22S938,803,937,800c-1-1-1-4-3-4-.23,0-27,1-30,9-1.48,1.48-7.75,38.36-7.32,45.72-10.06,2.21-26.83,26.24-31.59,34s-22.75,55.94-23,57-4.1,1.46-4.36,1.4-4.51-.25-5.26.65-.81,4.65-.81,4.65a70.65,70.65,0,0,0-4,6.85c-2.41,4.54-4.93,17.66-5.44,22.11s-1.25,26,2.12,34.61c-1.74,10.88-1.62,18.43-.92,22.36s4.47,6.15,5.62,7,8.88,3.42,8.88,3.42-.12.51,2.25,1.87,69.55,16.26,69.55,16.26,66.82,16.42,69.55,16.25,2.84-.67,2.84-.67,8.08,1.08,9.47.87,5.77-.54,8.13-3.75,5.82-9.92,9.08-20.44c6.82-6.2,15.72-25.88,17.25-30.1S1031.09,1007.88,1031,1002.74ZM951.71,847.46l2-.6,2.63,1.41.45.38Zm10.7,2.5.57-.14,3-.11,1.55,1.44Zm4.76-33c18.78,3.58,23.72,11.18,23.72,11.18a5,5,0,0,1-1.2.53c-.43,1.2-1,6.59-1.36,12.44L977.58,854l-6.87-1.71-1.84-3.55-3.94-.38-3.79,1.26-.07.28-1.52-.38-1.53-.34.06-.27-2.84-2.82-3.7-1.4-3.23,2.37-6.91-1.51L940,826c0-4,1.64-7.27,1.79-8.53a5,5,0,0,1-.84-1S948.75,811.84,967.17,817Z",
    transform: "translate(-820.77 -655)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacMauvaiseReponse1);
export default __webpack_public_path__ + "static/media/sac_mauvaise_reponse_1.8360d7b16fd649dbb1e88df80790ce12.svg";
export { ForwardRef as ReactComponent };